import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MODULE_LIVE_CHAT, ModulesService } from '../services/modules.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isLoggedIn()) {
    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

export const userManagerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.canManageUsers()) {
    return true;
  }

  return router.createUrlTree(['/admin']);
};

export const portalAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.canManageModules()) {
    return true;
  }

  return router.createUrlTree(['/admin']);
};

/** Live-chat inbox: BusinessAdmin + live-chat module enabled (not PortalAdmin). */
export const chatAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const modules = inject(ModulesService);
  const router = inject(Router);
  if (auth.canUseChat() && modules.isEnabled(MODULE_LIVE_CHAT)) {
    return true;
  }

  return router.createUrlTree(['/admin']);
};
